import { Image, StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { useTheme } from '../../hooks/useTheme';

const DEFAULT_AVATAR = require('../../../assets/default-avatar.png');

interface UserAvatarProps {
  imageUrl?: string | null;
  size?: number;
  style?: StyleProp<ViewStyle>;
  withBorder?: boolean;
  borderColor?: string;
}

export function UserAvatar({
  imageUrl,
  size = 48,
  style,
  withBorder = false,
  borderColor,
}: UserAvatarProps) {
  const { theme } = useTheme();
  const source = imageUrl ? { uri: imageUrl } : DEFAULT_AVATAR;
  const resolvedBorderColor = borderColor ?? theme.borderSubtle;

  return (
    <View
      style={[
        styles.wrap,
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: theme.surfaceSecondary,
          borderWidth: withBorder ? StyleSheet.hairlineWidth : 0,
          borderColor: withBorder ? resolvedBorderColor : 'transparent',
        },
        style,
      ]}
    >
      <Image
        source={source}
        style={{ width: size, height: size, borderRadius: size / 2 }}
        resizeMode="cover"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
});
